<template>
    <div>

        <div class="cc-banner"
            data-content-text="Nous utilisons des cookies et d'autres technologies pour améliorer et personnaliser votre expérience utilisateur, des analyses pour l'optimisation et des publicités en partenariat avec des tiers. Nous utilisons nos propres cookies et des cookies de tiers. En cliquant sur OK, vous acceptez l'utilisation de tous les cookies. Nous installons toujours les cookies nécessaires. Sélectionnez {preferencesUrl}Gérer vos préférences{/preferencesUrl} pour choisir les cookies que vous souhaitez accepter, ajuster votre préférence et trouver plus d'informations."
            data-url="https://www.just-eat.ch/fr/cookiestatement"
            data-url-text="Gérer vos préférences."
            data-hide-link-after-text="true"
            data-button-text="OK"
            data-button-text-aria="OK Button"
            data-button-essential-package="Essentiels"
            data-button-essential-package-aria="Essential package aria"
            v-if="isCHFR">
        </div>


        <div class="cc-banner"
        data-content-text="Wir verwenden Cookies und andere Technologien, um Dein Benutzererlebnis zu verbessern und zu personalisieren, für Analysen zur Optimierung und Werbung in Zusammenarbeit mit Dritten. Wir verwenden unsere eigenen Cookies und Cookies von Dritten. Wenn Du auf OK klickst, akzeptierst Du die Verwendung aller Cookies. Wir setzen immer notwendige Cookies. Wähle {preferencesUrl}Einstellungen verwalten{/preferencesUrl}, um zu entscheiden, welche Cookies Du akzeptieren möchtest, um Deine Präferenzen anzupassen und um weitere Informationen zu finden."
        data-url="https://www.just-eat.ch/cookiestatement"
        data-url-text="Einstellungen verwalten."
        data-hide-link-after-text="true"
        data-button-text="OK"
        data-button-text-aria="OK Button"
        data-button-essential-package="Essentielle"
        data-button-essential-package-aria="Essential package aria"
        v-if="isCHDE">
        </div>


    </div>
</template>

<script>
let lang = process.env.VUE_APP_LOCALITY;

export default {
    mounted() {
        window.addEventListener('load', () => this.addCookies());
    },
    data: function() {
        return {
            isCHFR: lang == 'ch_fr' ? true : false,
            isCHDE: lang == 'ch_de' ? true : false,
        }
    },
    methods: {
        addCookies() {
            let cookie;
            let name = "cookieConsent=";
            let decodedCookie = decodeURIComponent(document.cookie);
            let ca = decodedCookie.split(';');

            for(let i = 0; i <ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    cookie = c.substring(name.length, c.length);
                }
            }

            if (cookie == undefined) {

                let cookiesScript = document.createElement('script')
                cookiesScript.setAttribute('src', 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/cookie-styles-09-2022/cookie-wall-with-polyfill.59c6866ee421a693445a.js');
                document.head.appendChild(cookiesScript);

            }
        }
    }
}
</script>